import { StorageService } from './../../../services/storage.service';
import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ReactiveFormsModule, FormsModule, FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { UsersService } from '../../../services/admin/users.service';
import { newUser } from '../../../models/newUser';
import { ToasterModule, ToasterService, Toast } from 'angular5-toaster';
import { TranslateService } from '@ngx-translate/core';
import { passwordValidator } from '../../../shared/validators/password.validator';


@Component({
  selector: 'app-form-register',
  templateUrl: './form-register.component.html',
  styleUrls: ['./form-register.component.scss']
})
export class FormRegisterComponent implements OnInit {
  rows_sociedades = [];
  centros_costo = [];
  public registrationForm: FormGroup;
  public submitted: Boolean = false;
  public error = null;
  busy: Boolean = false;
  toastErrorRegistroUsuario;
  constructor(
    private translate: TranslateService,
    public activeModal: NgbActiveModal,
    private formBuilder: FormBuilder,
    public userService: UsersService,
    private toasterService: ToasterService,
    private storageService: StorageService
  ) {
    this.translate.get('texto.toastErrorRegistroUsuario').subscribe(
      text => {
        this.toastErrorRegistroUsuario = text;
      });
  }

  ngOnInit() {

    this.registrationForm = this.formBuilder.group({
      name: ['', Validators.compose([
        Validators.required, Validators.minLength(2), Validators.maxLength(70), this.noWhitespaceValidator
      ])],
      id: ['', Validators.required],
      rfc: ['', Validators.required],
      username: ['', Validators.required],
      email: ['', Validators.compose([Validators.required,
      Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,3}$'),
      Validators.minLength(1)])],
      password: ['', [Validators.required, passwordValidator]],
      telefono: [''],
      direccion: [''],
      rol: ['', Validators.required]
    })

  }

  get passwordValue(): string {
    return this.registrationForm.get('password').value || '';
  }

  closeModal() {
    this.activeModal.close('Modal Closed');
  }

  public noWhitespaceValidator(control: FormControl) {
    let isWhitespace = (control.value || '').trim().length === 0;
    let isValid = !isWhitespace;
    return isValid ? null : { 'whitespace': true }
  }


  public submitUserData(): void {
    this.submitted = true;
    this.error = null;

    if (this.registrationForm.valid) {
      this.busy = true;
      let userData: newUser = this.registrationForm.value;
      userData.rol = { id: this.registrationForm.value.rol };
      userData.nombre = this.registrationForm.value.name;

      this.userService.createUser(userData).subscribe(
        data => {
          this.busy = false;
          if (data != null) {

            this.correctRegistration(data);
          }

          //  console.log(resp.headers.get('Cookie'));
        },
        error => {
          this.busy = false;
          this.error = error
        }
      )
    } 
  }


  private correctRegistration(data) {
    if (data != null) {

      if (data.success) {

        this.activeModal.close('succes');
        this.toasterService.pop('success', data.message);

      } else {
        this.toasterService.pop('error', data.message);
      }



    } else {
      //Handle no sesion data
      this.toasterService.pop('error', this.toastErrorRegistroUsuario);

    }
  }

  // validaciones de contraseña segura
  passwordHasError(errorKey: string): boolean {
    const passwordControl = this.registrationForm.get('password');
    if (!passwordControl || !passwordControl.errors) {
      return true; // no hay error
    }

    return !passwordControl.errors[errorKey];
  }

  get hasMinLength(): boolean { return this.passwordHasError('minLength') }
  get hasUppercase(): boolean { return this.passwordHasError('noUppercase') }
  get hasLowercase(): boolean {  return this.passwordHasError('noLowercase') }
  get hasNumber(): boolean {  return this.passwordHasError('noNumber') }
  get hasSpecialChar(): boolean { return this.passwordHasError('noSpecial') }

}



// WEBPACK FOOTER //
// ./src/app/pages/users/form-register/form-register.component.ts